import React from "react";
import note from "../../../assets/img/icons/note-2.svg";
import check from "../../../assets/img/icons/task.svg";
import cancel from "../../../assets/img/icons/cancel-red.svg";
import arrow from "../../../assets/img/icons/arrow-down.svg";
const PlaceRules = ({inforesidencedetail}) => {
  return (
    <div className="PlaceRules py-[40px]">
      <div className="PlaceReserve">
        <img src={note} />
        <div>
          <p className="text-[#12171C] text-[20px] font-[700] ">
            قوانین و مقررات اقامتگاه
          </p>
          <p className="text-[#51555A] text-[18px] font-[600] mt-[4px] w-[75%]">
            دانستن قوانین و مقررات از ساعات ورود و خروج گرفته تا امکان برگذاری
            مراسم و ... کمک شایانی می کند تا در اقامتگاه متناسب با خودتان در طول
            سفر سکونت پیدا کنید
          </p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 sm:grid-cols-2 grid-cols-1 :gap-[92px]">
        <div>
          <div className="flex gap-[24px]">
            <div className="PlaceRules-box">
              <h5>ساعت ورود :</h5>
              <p>از ساعت {inforesidencedetail.regulation.entrance_time} تا {inforesidencedetail.regulation.entrance_time_to}</p>
            </div>
            <div className="PlaceRules-box">
              <h5>ساعت خروج :</h5>
              <p>تا ساعت {inforesidencedetail.regulation.leaving_time}</p>
            </div>
          </div>
          <p className="mt-[50px] font-[500] text-[#292D32] text-[18px]">
            هزینه کودکان زیر ۵ سال رایگان نیست و جزو نفرات حساب می شود.پذیرش
            نهایتا تا ساعت ۱۰ شب امکان پذیر است.کارت ملی هوشمند از تمامی
            میهمانان دریافت می شود.از آوردن قلیان و استعمال قلیان داخل واحد
            خودداری شود در صورت مشاهده خروج مسافر بدون کنسلی و همراه با جریمه
            انجام می شود.
          </p>
        </div>
        <div>
          <div>
           {inforesidencedetail.regulation.pet_check_in === 1 ? <div className="flex items-center">
              <img src={check} />
              <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
                در این اقامتگاه امکان ورود حیوان خانگی ممکن می باشد
              </p>
            </div> :<div className="flex items-center">
              <img src={cancel} />
              <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
                در این اقامتگاه امکان ورود حیوان خانگی ممکن نمی باشد
              </p>
            </div>  }
           { inforesidencedetail.regulation.party === 1 ? <div className="flex items-center my-[30px]">
              <img src={check} />
              <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
              برگذاری مهمانی امکان پذیر میباشد
              </p>
            </div>:
            <div className="flex items-center my-[30px]">
            <img src={cancel} />
            <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
            برگذاری مهمانی امکان پذیر نمیباشد
            </p>
          </div>}
          { inforesidencedetail.regulation.smoking === 1 ? <div className="flex items-center my-[30px]">
              <img src={check} />
              <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
             مصرف سیگار مجاز میباشد
              </p>
            </div>:
            <div className="flex items-center my-[30px]">
            <img src={cancel} />
            <p className="mr-[12px] font-[500] text-[#292D32] text-[18px]">
            مصرف سیگار مجاز نمیباشد
            </p>
          </div>}
          </div>
          <div className="mb-[30px] mt-[40px]">
            <h4 className=" font-[700] text-[#292D32] text-[18px]">
              مدارک مورد نیاز :
            </h4>
            <ul>
              <li>کارت ملی هوشمند از تمامی میهمانان دریافت می شود.</li>
            </ul>
          </div>
          <div className="mb-[30px] mt-[40px]">
            <h4 className=" font-[700] text-[#292D32] text-[18px]">
              شرایط کنسلی و لغو رزرو : (سخت گیرانه){" "}
            </h4>
            <ul>
              <li>کسر مبلغ پرداختی به عنوان خسارت</li>
              <li>در صورت کنسل کردن رزرو مبلغی بازگشت داده نمی شود </li>
            </ul>
          </div>
          <div className="flex items-center">
            <p className="ml-[8px]  font-[700] text-[#00A6A6] text-[18px]"> مطالعه کامل قوانین</p>
            <img src={arrow} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceRules;
